import * as Schemas from './apis/wfbApiSchemas';
import {
  ActionTask,
  CodeTask,
  Conditional,
  ContinuousLoading,
  DataConnector,
  Repeated,
} from './apis/wfbApiSchemas';

export { Schemas };
export * from './apis/wfbApiComponents';
export * from './useWorkflowPlan';
export * from './useSaveWorkflow';

export type WorkflowConfigInput = Schemas.WorkflowConfigInput;

export type ActionTaskInput = Schemas.ActionTaskInput;
export type ConditionalInput = Schemas.ConditionalInput;
export type RepeatedTaskListInput = Schemas.RepeatedInput;
export type ContinuousLoadingInput = Schemas.ContinuousLoadingInput;

export type ScriptFunctionInfo = Schemas.ScriptFunctionInfo;

export type CodeTaskInput = Schemas.CodeTaskInput;

export type DataConnectorInput = Schemas.DataConnectorInput;

export type ActionTasksById = { [taskId: string]: ActionTaskInput };

export type CodeTasksById = { [taskId: string]: CodeTaskInput };

export type Action = Schemas.Action;

export type OrgScriptsInfo = Schemas.OrgScriptsInfo;

export type TaskOutputReferenceInput = Schemas.TaskOutputReferenceInput;

export type Driver = Schemas.Driver;

export type PlannerOptionsInput = Schemas.PlannerOptionsInput;

export type DriverAction = Driver['actions'][string];
export type DriverArgument = Schemas.Argument;
export type DriverArguments = Record<string, DriverArgument>;
export type DriverUnits = Schemas.Units;

export type WorkcellInstrumentConfig = Schemas.WorkcellInstrument['config'];

export const NO_DEFAULT = 'NO_DEFAULT';

export type TaskInputUnion = ActionTaskInput | CodeTaskInput | ConditionalInput;

export function isCodeTaskInput(input: TaskInputUnion): input is CodeTaskInput {
  return (input as CodeTaskInput).function !== undefined;
}

export function isConditionalInput(
  input:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | RepeatedTaskListInput
    | ContinuousLoadingInput
): input is ConditionalInput {
  return 'type' in input && input.type === 'conditional';
}

export function isContinuousLoadingInput(
  input:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | RepeatedTaskListInput
    | ContinuousLoadingInput
): input is ContinuousLoadingInput {
  return 'type' in input && input.type === 'continuous_loading';
}

export function isActionTaskInput(
  input:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | RepeatedTaskListInput
    | ContinuousLoadingInput
): input is ActionTaskInput {
  return 'type' in input && input.type === 'action';
}

export function isRepeatedTaskListInput(
  input:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | RepeatedTaskListInput
    | ContinuousLoadingInput
): input is RepeatedTaskListInput {
  return (
    !isConditionalInput(input) &&
    !isActionTaskInput(input) &&
    'repetitions' in input
  );
}

type LabwareLocation =
  | Schemas.LocationInput
  | Schemas.LocationRangeInput
  | (Schemas.LocationRangeInput | Schemas.LocationInput)[];

export const isLocationInput = (
  input: LabwareLocation
): input is Schemas.LocationInput => 'slot' in input;

export const isLocationRangeInput = (
  input: LabwareLocation
): input is Schemas.LocationRangeInput =>
  'start_slot' in input && 'end_slot' in input;

export const isActionTask = (
  task:
    | ActionTask
    | CodeTask
    | DataConnector
    | Conditional
    | Repeated
    | ContinuousLoading
): task is ActionTask => 'type' in task && task.type === 'action';
